import { useConfig } from 'config';
import Link from 'next/link';
import { FormattedMessage } from 'react-intl';

const PrivacyProtectionLink: React.FC = () => {
  const { commonLinks } = useConfig();

  return (
    (<Link
      href="/pages/[handle]"
      as={`/pages/${commonLinks.dataProtection}`}
      passHref
      className="text-primary-main">

      <FormattedMessage id="cookie-banner:privacy-link" />

    </Link>)
  );
};

export default PrivacyProtectionLink;
